import {
  AccordionButton as ChakraAccordionButton,
  AccordionButtonProps as ChakraAccordionButtonProps
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import DisplayNames from './enums';

import { Box, Icon } from 'index';
import { forwardRef } from 'system';

export type AccordionButtonProps = ChakraAccordionButtonProps & {
  iconType?: string;
};

const propTypes = {
  iconType: PropTypes.string
};

const defaultProps = {
  iconType: undefined
};

const AccordionButton = forwardRef(
  (props: AccordionButtonProps, ref: React.MutableRefObject<HTMLButtonElement>): React.ReactElement => {
    const { children, iconType, ...rest } = props;

    return (
      <ChakraAccordionButton {...rest} ref={ref}>
        {iconType && (
          <Box>
            <Icon boxSize="24px" marginRight="8px" type={iconType} />
          </Box>
        )}
        {children}
      </ChakraAccordionButton>
    );
  }
);

AccordionButton.displayName = DisplayNames.AccordionButton;
AccordionButton.propTypes = propTypes;
AccordionButton.defaultProps = defaultProps;

export default AccordionButton;
